<template>
    <component :is="href ? 'a' : 'button'" :href="href" class="relative block text-left rounded-xl bg-gray-50 border p-6 pb-24 cursor-pointer hover:shadow-xl hover:border-blue-500 transition" @click="$emit('click')">
        <h2 class="text-sm text-gray-500 font-medium" v-text="label"></h2>

        <!-- Content. -->
        <p v-if="loading" class="text-2xl text-gray-400 font-semibold">Loading...</p>
        <div v-else class="flex items-baseline space-x-4">
            <p class="text-2xl text-gray-900 font-semibold" v-text="value"></p>
            <p class="text-lg text-gray-500 font-semibold" v-text="secondaryValue"></p>
            <slot name="additional-content"></slot>
        </div>

        <!-- Charts. -->
        <div v-show="loading" class="absolute bottom-0 inset-x-0">
            <div class="relative w-full h-20 rounded-b-xl overflow-hidden animate-pulse-fade">
                <canvas ref="loadingChart" class="block"></canvas>
            </div>
        </div>
        <div v-show="!loading && secondaryChart" class="absolute bottom-0 inset-x-0">
            <div class="relative w-full h-20 rounded-b-xl overflow-hidden">
                <canvas ref="secondaryChart" class="block"></canvas>
            </div>
        </div>
        <div v-show="!loading && chart" class="absolute bottom-0 inset-x-0">
            <div class="relative w-full h-20 rounded-b-xl overflow-hidden">
                <canvas ref="chart" class="block"></canvas>
            </div>
        </div>
    </component>
</template>

<script>
import { createCardLineChart } from '@utils';

export default {
    props: {
        href: String,
        label: String,
        value: null,
        secondaryValue: null,
        chart: Object | Array,
        secondaryChart: Object | Array,
        loading: Boolean,
    },
    data () {
        return {
            loadingChartInstance: null,
            chartInstance: null,
            secondaryChartInstance: null,
        }
    },
    methods: {
        upsertChart (data) {
            if (! data) return
            if (! this.chartInstance) {
                this.chartInstance = createCardLineChart(this.$refs.chart, this.chart, '#06b6d4', '#22d3ee')
            } else {
                this.chartInstance.data.datasets[0].data = data
                this.chartInstance.update()
            }
        },
        upsertSecondaryChart (data) {
            if (! data) return
            if (! this.secondaryChartInstance) {
                this.secondaryChartInstance = createCardLineChart(this.$refs.secondaryChart, this.secondaryChart, '#cbd5e1', '#cbd5e1')
            } else {
                this.secondaryChartInstance.data.datasets[0].data = data
                this.secondaryChartInstance.update()
            }
        },
    },
    mounted() {
        const loadingChartData = { a: 12, b: 14, c: 43, d: 7, e: 30, f: 35 }
        this.loadingChartInstance = createCardLineChart(this.$refs.loadingChart, loadingChartData, '#e2e8f0', '#e2e8f0')
        this.upsertChart(this.chart)
        this.upsertSecondaryChart(this.secondaryChart)
    },
    watch: {
        chart: 'upsertChart',
        secondaryChart: 'upsertSecondaryChart',
    },
}
</script>
